// extracted by mini-css-extract-plugin
export var cardLayout = "_8t-1";
export var paginationContainer = "_8t-0";